import { highlightStyle } from '../config/query-highlight-utilities';
import PropTypes from 'prop-types';

//This component is used to display a list of contact data (like emails, phones, etc.) in a formatted way
//It highlights the matched items based on the search query provided
//It is used in the SimpleContactsTable component (for emails and phones column) to display data in a searchable format
const ContactDataList = ({ items, getValue, isMatched }) => {
  if (!items || !items.length) return <span aria-label="-">-</span>;
  return (
    <span aria-label={items.map(getValue).join(', ')} className="fs-exclude-data">
      {items.map((item, idx) => (
        <span
          key={getValue(item) || idx}
          style={isMatched(item) ? highlightStyle : { ...highlightStyle, backgroundColor: 'transparent' }}
        >
          {getValue(item)}
          {idx < items.length - 1 ? ', ' : ''}
        </span>
      ))}
    </span>
  );
};

ContactDataList.propTypes = {
  items: PropTypes.array.isRequired,
  getValue: PropTypes.func.isRequired,
  isMatched: PropTypes.func.isRequired,
};

export default ContactDataList;
